<ion-menu contentId="main-content" swipeGesture="false">
  <div class="menu-header viva-page">
    <h3 *ngIf="profile">{{profile.firstName}} {{profile.lastName}}</h3>
    <small>Version {{versionNumber}}</small>
  </div>
  <ion-content class="ion-padding menu-border">
    <ion-list>
      <ion-item class="menu-item" (click)="goToStories()">
        <ion-icon name="home-outline" slot="start"></ion-icon>
        <ion-label>
          <h3>Select Story</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>
      
      <ion-item class="menu-item" (click)="myProfile()" [disabled]="!isOnline">
        <ion-icon name="person-outline" slot="start"></ion-icon>
        <ion-label>
          <h3>Profile</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>
    </ion-list>
  </ion-content>
</ion-menu>

